const routeRules = {
  landingPage: '/',
  dashboard: '/dashboard',
  userdetails: '/user-detail',
  addoreditethnicity: '/addoreditethnicity',
  usermanagement: '/usermanagement',
  subscriptioninfo: '/subscriptioninfo',
  Supportmanagement: '/Supportmanagement',
  supportdetails: '/supportdetails',
  messageManagement: '/messageManagement',
  messagedetails: '/messagedetails',
  PushNotification: '/PushNotification',
  analytics: '/analytics',
  reportmanagement: '/reportmanagement',
  InfluencerUser: '/InfluencerUser',
  Referralmanagement: '/Referralmanagement',
  influencerDetails: '/influencerDetails',
  editInfluencerUser: '/editInfluencerUser',
  PremiumPackage: '/PremiumPackage',
  BloomPackage: '/BloomPackage',
  PremiumUser: '/PremiumUser',
  BloomUser: '/BloomUser',
  FreeUser: '/FreeUser',
  FreeUserSubscriptionList: '/FreeUserSubscriptionList',
  UserSubscriptionList: '/UserSubscriptionList',
  UserBloomList: '/UserBloomList',
  AddorEditPackage: '/AddorEditPackage',
  AddorEditPackages: '/AddorEditPackages',
  UserScanDetails: '/UserScanDetails',
  contentmanagement: '/contentmanagement',
  ethnicityManagement: '/ethnicityManagement',
  noticontent: '/noticontent',
  addoredituser: '/addoredituser',
  addoreditdream: '/addoreditdream',
  addoreditdreampartner: '/addoreditdreampartner',
  addoreditrelation: '/addoreditrelation',
  addoreditintersted: '/addoreditintersted',
  addoredithobbies: '/addoredithobbies',
  addoreditmyself: '/addoreditmyself',
  addorediteducation: '/addorediteducation',
  addoreditreligion: '/addoreditreligion',
  addoreditimportancereligion: '/addoreditimportancereligion',
  forget: '/forgot',
  resetpassword: '/resetpassword',
  resetadminpassword: '/resetadminpassword',
  verifyMail: '/verifyMail',
  scandetails: '/scandetails',
  profile: '/profile',
  appVersion: '/appVersion',
  dreamanagement: '/dreamanagement',
  dreamPartnerManagement: '/dreamPartnerManagement',
  dreamdetails: '/dream-detail',
  relationshipmanagement: '/relationshipmanagement',
  interstedmanagement: '/interstedmanagement',
  hobbiesmanagement: '/hobbiesmanagement',
  myselfmanagement: '/myselfmanagement',
  importanceReligionManagement: '/importanceReligionManagement',
  educationmanagement: '/educationmanagement',
  religionmanagement: '/religionmanagement',
  termsandconditions: '/termsandconditions',
  audiovideocalls: '/audiovideocalls',
  usersFeedback: '/usersFeedback',
  inviteFriends: '/inviteFriends',
};

export default routeRules;
